import { makeStyles } from "@material-ui/core";

const styles = makeStyles(() => ({
  filter: {
    width: "180px",
  },
}));

export default styles;
